import { FormikProps } from 'formik';
import { cloneDeep } from 'lodash';
import { MouseEvent, useCallback } from 'react';
import { CultureEntry } from '../../../../../interfaces/cultures';

export const useHandleRemove = <T>(props: FormikProps<T>, name: string) => {
  return useCallback(
    (index: number) => (event: MouseEvent<HTMLButtonElement>) => {
      const currentValue = props.getFieldProps(name)
        .value as CultureEntry<string>[];

      let currentCopy = cloneDeep(currentValue);
      currentCopy = currentCopy.filter((_, idx) => index !== idx);
      props.setFieldValue(name, currentCopy);
    },
    [name, props]
  );
};
